export const SAVE_REGISTER_INFO = "SAVE_REGISTER_INFO";
